export const EVENTS = {
  PASSWORD_RESET: {
    REQUESTED: 'password_reset.requested',
    SHOW_NEW_PASSWORD_INPUT: 'password_reset.show_new_password_input',
    SUBMIT_NEW_PASSWORD: 'password_reset.submit_new_password',
    RESET_SUCCESS: 'password_reset.reset_success',
    RESET_ERROR: 'password_reset.reset_error',
    CANCEL: 'password_reset.cancel',
  }
};
